<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label required">{{
          $t('studentCardActivator.studentName')
        }}</label>
        <ts-loading-banner :loading="loadingPreData">
          <!-- <treeselect
            :placeholder="$t('studentCardActivator.typeforsearch')"
            :options="
              students.map(i => ({
                id: i.student_id,
                label: i.full_name_en + ' | ' + i.full_name_kh
              }))
            "
            v-model="model.student_id"
          ></treeselect> -->
          <ts-select-student v-model.number="model.student_id" />
        </ts-loading-banner>
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('student_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label required">{{
          $t('studentCardActivator.serialCard')
        }}</label>
        <input
          v-model="model.serial_card"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('serial_card') }"
        />
        <div class="invalid-feedback" v-if="errors.has('serial_card')">
          {{ errors.first('serial_card') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          >{{ $t('save') }}</ts-button
        >
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import FormComponent from './confirm-deactivate-old-card.vue'
import TsSelectStudent from '@/components/SelectStudent'

export default {
  name: 'student-card-activator-form',
  components: { TsSelectStudent },
  data () {
    return {
      model: {
        student_id: null,
        serial_card: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false,
      loadingPreData: false
    }
  },
  computed: {
    ...mapState('studentCardActivator', ['students'])
  },
  methods: {
    cancel () {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'student-card-activator' })
    },

    async checkStudentCardStatus (data) {
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'studentCardActivator/checkCurrentStudentCardStatus',
          data
        )
        if (response.status == true) {
          this.saving = false
          this.showForm(data)
        }

        return response.status
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
    },

    showForm (data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },

    async save () {
      this.saving = true
      this.errors = new Errors()
      this.check = await this.checkStudentCardStatus(this.model)
      if (this.check == false) {
        this.saving = false
        try {
          let response = await this.$store.dispatch(
            'studentCardActivator/create',
            this.model
          )
          this.$toasted.success(response.message)
          this.$emit('success_create')
          this.clearForm()
        } catch (error) {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        }
        this.saving = false
      }
      this.saving = false
    },

    clearForm () {
      this.model = {
        student_id: '',
        serial_card: ''
      }
    }
  }
}
</script>
